// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Guideline_wrapper__1hfEy","guidelineImages":"Guideline_guidelineImages__20EoN","imageContainer":"Guideline_imageContainer__3TYie","image":"Guideline_image__1J_0R"};